import React, {useEffect, useContext, useState} from 'react';

import {AuthContext} from '../../context';
import {createCompany, getServices} from '../../api';
import {unauthorized} from '../../utils';
import {PageContainer, FormAdmin, Notification} from '../../components';

const NewCustomer = ({history}) => {
  const {user} = useContext(AuthContext);
  const [services, setServices] = useState();
  const [loading, setLoading] = useState(true);
  const [companyName, setCompanyName] = useState('');
  const [endOfUseDate, setEndOfUseDate] = useState('');
  const [selectedEmail, setSelectedEmail] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState('');
  const [team, setTeam] = useState([
    {
      firstname: '',
      lastname: '',
      email: '',
      profession: '',
      phone: '',
    },
  ]);

  const handleServices = async () => {
    setError('');

    const data = await getServices();
    await unauthorized(data.error, history);
    if (data.error) return setError(data.error);

    const servicesTemp = [];
    data.map((service) => {
      servicesTemp.push({
        value: service._id,
        label: service.name,
        credits: '',
        isSelected: false,
        unlimited: false,
      });
    });
    setServices(servicesTemp);
    setLoading(false);
  };

  const changeTeam = (e, teammateIndex) => {
    const copyTeammate = [...team];
    copyTeammate[teammateIndex][e.target.name] = e.target.value;
    setTeam(copyTeammate);
  };

  const changeServices = (e, index) => {
    const copy = [...services];
    copy[index].isSelected = !copy[index].isSelected;
    setServices(copy);
  };

  const changeCredits = (e, index) => {
    const copy = [...services];
    copy[index][e.target.name] = e.target.value;
    setServices(copy);
  };

  const changeUnlimited = (e, index) => {
    const copy = [...services];
    copy[index].unlimited = !copy[index].unlimited;
    copy[index].credits = copy[index].unlimited && 0;
    setServices(copy);
  };

  const addTeammate = () => {
    setTeam([
      ...team,
      {
        firstname: '',
        lastname: '',
        email: '',
        profession: '',
        phone: '',
      },
    ]);
  };

  const removeTeammate = (e, index) => {
    const filtered = team.filter((t) => t !== team[index]);
    setTeam(filtered);
  };

  const handleCreateCompany = async (e) => {
    e.preventDefault();
    setError();

    const formattedServices = [];
    services.map((s) => {
      s.isSelected &&
        formattedServices.push({
          service: s.value,
          credits: parseInt(s.credits, 10),
          unlimited: s.unlimited,
        });
    });

    const data = await createCompany({
      name: companyName,
      team,
      services: formattedServices,
      endOfUseDate,
      selectedEmail,
    });
    setIsOpen(false);
    await unauthorized(data.error, history);
    if (data.error) return setError(data.error);

    setIsOpen(false);
    setLoading(false);
    history.push({pathname: '/admin', state: "L'entreprise a bien été créée."});
  };

  useEffect(() => {
    handleServices();
  }, []);

  if (loading) return <p>loading</p>;

  return (
    <PageContainer role={user.infos.role} companyName="Sublissime" title="Nouveau client">
      <FormAdmin
        services={services}
        changeServices={changeServices}
        changeCredits={changeCredits}
        changeUnlimited={changeUnlimited}
        changeCompanyName={setCompanyName}
        changeDate={setEndOfUseDate}
        changeTeam={changeTeam}
        changeIsOpen={setIsOpen}
        changeSelectedEmail={setSelectedEmail}
        addTeammate={addTeammate}
        removeTeammate={removeTeammate}
        companyName={companyName}
        team={team}
        endOfUseDate={endOfUseDate}
        isOpen={isOpen}
        handleSubmit={handleCreateCompany}
        selectedEmail={selectedEmail}
      />
      {error && <Notification type="error" text={error} />}
    </PageContainer>
  );
};

export default NewCustomer;
